<p-toast key="doPlanning"></p-toast>


<p-select
  #planningSelect
  [options]="plannings"
  [(ngModel)]="selectedplan"
  optionLabel="label"
  optionValue="value"
  placeholder="NAČRTOVANJE SISTEMOV"
  appendTo="body"
  panelStyleClass="planning-select-panel"
  (onChange)="doPlan($event.value)"
  (onHide)="onPlanningHide()"
>
</p-select>



<!-- NAČRTOVANJE DALJINSKIH OGREVANJ POPUP -->

<p-dialog
  [(visible)]="visibleDialogPlanning_1"
  [header]="'Načrtovanje daljinskega ogrevanja'"
  [closable]="true"
  (onAfterHide)="dlg_1Hide($event)"
  appendTo="body"
  [resizable]="false"
>
  <app-remote-power
    [infoEvent]="infoEvent"
    [doFindOptsSelected]="doFindOptsSelected"
    (onCloseEmmiter)="onClsoeDialog($event)"
  ></app-remote-power>
</p-dialog>




<!-- NAČRTOVANJE SONČNIH ELEKTRARN POPUP -->

<p-dialog
  [(visible)]="visibleDialogPlanning_2"
  [header]="'Načrtovanje sončnih elektrarn'"
  [closable]="true"
  appendTo="body"
  (onAfterHide)="dlg_2Hide($event)"
  [resizable]="false"
>
    <p-select [options]="powerPlantTypes" [(ngModel)]="selectedPowerPlantType"
        (onChange)="doSelectPowerPlantType($event)" [style]="{width:'300px'}"></p-select>
    <br />
    <br />
    <div *ngIf="(selectedPowerPlantType === 1)">
        <p-selectButton [options]="pptFindOpts" [(ngModel)]="pptFindOptsSelected"
            (onChange)="pptFindOptsAction($event)"></p-selectButton>
        <br />
        <br />
        <div *ngIf="(pptFindOptsSelected === 1)" id="powerPlantAreaSrchForm">

            <form [formGroup]="powerPlantAreaSrchForm" (ngSubmit)="onSubmitPPF()">

                <div class="wrapper2">
                    <div>
                        <h5>Tip območja</h5>

                        <label class="inputcontainer"> Minimalna moč elektrarne [MW] <input type="number" align="right"
                                formControlName="minimalpowerMW"></label>

                        <label class="inputcontainer"> Največja oddaljenost od transformatorske postaje [m] <input
                                type="number" formControlName="maxLengthFromNearestTrafoStationMeters"></label>

                        <label class="inputcontainer"> Največja oddaljenost od najbližje dostopne ceste [m] <input
                                type="number" formControlName="maxLengthFromNearestRoadMeters"></label>

                        <label class="container">Degradirane površine <input type="checkbox"
                                formControlName="areatype_dp"> <span class="checkmark"></span> </label>

                        <label class="container">Območja za energetsko infrastrukturo <input type="checkbox"
                                formControlName="areatype_oei"> <span class="checkmark"></span></label>

                        <label class="container">Druga potencialno primerna območja <input type="checkbox"
                                formControlName="areatype_ppo"> <span class="checkmark"></span></label>

                    </div>
                    <div>
                        <h5>Objekti</h5>
                        <label class="container">Na območju so lahko prisotni objekti <input type="checkbox"
                                formControlName="buildings_allowed"> <span class="checkmark"></span></label>
                    </div>
                </div>
                <div class="wrapper2">
                    <div>
                        <h5>Lastništvo parcel</h5>


                        <label *ngIf="! powerPlantAreaSrchForm .controls['parcels_all'].value" class="inputcontainer">
                            Največje število lastnikov parcel <input type="number"
                                formControlName="maxParcelsOwners"></label>
                        <label class="container">Vse parcele<input type="checkbox" formControlName="parcels_all"><span
                                class="checkmark"></span></label>
                        <label class="container">Parcele pravnih oseb <input type="checkbox"
                                formControlName="parcels_po"><span class="checkmark"></span></label>
                        <label class="container">Državne parcele <input type="checkbox"
                                formControlName="parcels_dp"><span class="checkmark"></span></label>
                        <label class="container">Občinske parcele <input type="checkbox"
                                formControlName="parcels_op"><span class="checkmark"></span></label>
                    </div>

                    <div>
                        <h5>Izločanje območij glede na dejansko rabo</h5>

                        <label class="container">Gozd <input type="checkbox" formControlName="rp_g"> <span
                                class="checkmark"></span></label>
                        <label class="container">Pozidano in sorodno zemljišče <input type="checkbox"
                                formControlName="rp_psz"> <span class="checkmark"></span></label>
                        <label class="container">Suho, odprto zemljišče s posebnim rastlinskim pokrovom <input
                                type="checkbox" formControlName="rp_soprp"> <span class="checkmark"></span></label>
                        <label class="container">Odprto zemljišče brez ali z nepomembnim rastlinskim pokrovom <input
                                type="checkbox" formControlName="rp_onrp"> <span class="checkmark"></span></label>
                        <label class="container">Voda<input type="checkbox" formControlName="rp_v"> <span
                                class="checkmark"></span></label>

                    </div>
                </div>

                <button class="button" type="submit">Analiza</button>
            </form>
        </div>

        <div *ngIf="(pptFindOptsSelected === 2)">
            <p-selectButton [options]="drawopts" [(ngModel)]="drawoptselected" (onChange)="drawAction($event,2)">
            </p-selectButton>
        </div>
    </div>

    <div *ngIf="(selectedPowerPlantType === 2)">
        <p-selectButton [options]="roofTopPowerPlant" [(ngModel)]="selectedRoofTopPowerPlant"
            (onChange)="roofTopPowerPlantMode($event)"></p-selectButton>
        <div *ngIf="(selectedRoofTopPowerPlant === 1)">
            <br />
            <form [formGroup]="powerPlantRoofAddressSrchForm" (ngSubmit)="onSubmitPPARS()">
                <div class="wrapper2">
                    <div>
                        <h5>Izberi način proizvodnje</h5>
                        <p-select [options]="ssRoofLocationOptionsPS" formControlName="typePs"
                            [(ngModel)]="ssRoofLocationOptionsPSSelected"
                            (onChange)="doSelssRoofLocationOptionsPS($event)"></p-select>
                    </div>
                    <div>
                        <h5>Iskanje po naslovu</h5>
                        <app-search id="planning" (onselect)="onSelectectedSrch($event)"></app-search>
                    </div>

                </div>
                <div class="wrapper2">
                    <div *ngIf="powerPlantRoofAddressSrchForm .controls['typePs'].value === 2">
                        <div>
                            <label class="inputcontainer">Letna raba električne energije kWh <input type="number"
                                    align="right" formControlName="samooskrba"></label>
                        </div>
                        <div></div>
                    </div>
                </div>
                <button class="button" type="submit">Analiza</button>
            </form>
        </div>
        <div *ngIf="(selectedRoofTopPowerPlant === 2)">
            <br />
            <form [formGroup]="powerPlantRoofObjectSrchForm" (ngSubmit)="onSubmitPPORS()">
                <div class="wrapper2">
                    <div>
                        <h5>Prevladujoča raba objekta</h5>
                        <p-select [options]="rabeobjekta" [(ngModel)]="selectedraba" formControlName="raba">
                        </p-select>
                    </div>
                    <div>
                        <h5>Proizvodnja energije</h5>
                        <p-select [options]="ssLpeKwhkWp" formControlName="tlp" [(ngModel)]="ssLpeKwhkWpSelected"
                            (onChange)="doSelLpeType($event)"></p-select>
                        <label class="inputcontainer"><input type="number" align="right" formControlName="lp"></label>
                    </div>
                </div>
                <div class="wrapper2">
                    <div>
                        <h5>Lastništvo objekta</h5>
                        <label class="container">Država <input type="checkbox" formControlName="lastnik_drzava"> <span
                                class="checkmark"></span></label>
                        <label class="container">Občina <input type="checkbox" formControlName="lastnik_obcina"> <span
                                class="checkmark"></span></label>
                        <label class="container">Pravna oseba<input type="checkbox"
                                formControlName="lastnik_pravna_os"> <span class="checkmark"></span></label>
                        <label class="container">Fizična oseba<input type="checkbox"
                                formControlName="lastnik_fizicna_os"> <span class="checkmark"></span></label>
                    </div>
                    <div>
                        <h5>Tip strehe</h5>
                        <label class="container">Samo ravne strehe <input type="checkbox" formControlName="ravna_s">
                            <span class="checkmark"></span></label>
                    </div>
                </div>


                <div class="wrapper2">
                    <div>
                        <h5>Kulturna dediščina</h5>
                        <label class="container">Objekt ni spomeniško zaščiten <input type="checkbox"
                                formControlName="brez_kult_ded"> <span class="checkmark"></span></label>
                    </div>
                    <div>
                        <h5>Starost strehe in objekta</h5>
                        <label class="inputcontainer">Najdaljši čas od zadnje obnove strehe (v letih)<input type="number" min="0"
                                align="right" formControlName="l_ob_str"></label>
                        <label class="inputcontainer">Največja starost objekta (v letih)<input type="number" min="0"
                                align="right" formControlName="l_ob_obj"></label>
                    </div>
                </div>
                <div class="wrapper2">
                    <div>
                        <h5>Maksimalno število objektov v rezultatu</h5>
                        <label class="inputcontainer">Število ustreznih objektov (0 pomeni vsi)<input type="number"
                                align="right" formControlName="max_rs_obj"></label>
                    </div>
                    <div></div>
                </div>
                <button class="button" type="submit">Analiza</button>
            </form>
        </div>
    </div>
</p-dialog>



<!-- NAČRTOVANJE Toplotni sprejemniki sončne energije -->

<p-dialog
  [(visible)]="visibleDialogPlanning_3"
  [header]="'Toplotni sprejemniki sončne energije'"
  [closable]="true"
  appendTo="body"
  (onAfterHide)="dlg_1Hide($event)"
  [resizable]="false"
>
  <app-solar-receiver (onCloseEmmiter)="onClsoeDialog($event)"></app-solar-receiver>
</p-dialog>

